import styled from 'styled-components';

export const TabContainer = styled.ul`
  display: flex;
  margin-bottom: 0;
  padding-left: 0;
  flex-wrap: wrap;
  list-style: none;
`;

export const TabWrapper = styled.li`
  margin-right: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.small};
  padding-left: 0;
`;

export const Tab = styled.a`
  margin-bottom: 0;
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  display: flex;
  font-size: ${({ theme }) => theme.fontsize.h3};
  font-weight: ${({ $defaultChecked }) =>
    $defaultChecked ? 'bold' : 'normal'};
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.palette.disabled : theme.palette.standardText};
  text-decoration: none;
  border-bottom: ${({ $selected }) => ($selected ? '3px solid' : 'none')};
`;
